module.exports = __webpack_public_path__ + "templates.member_referral-39db7eb7.html";